import React, { useState } from "react";
import LoginForm from "../components/login-form";
import SignUp from "../components/sign-up/signUp";
import ForgotPassword from "../components/forgot-password/ForgotPassword";
import OTPForm from "../components/otp-page/OtpPage";
import ResetPassword from "../components/reset-password/resetPassword";
import { useAuth } from "../context/authContext";

type ActivePanel = "login" | "signup" | "forgot";

type Props = {
  activePanel: ActivePanel;
  onClose: () => void;
  onSwitch: (panel: ActivePanel) => void;
};

const LayoutManager: React.FC<Props> = ({ activePanel, onClose, onSwitch }) => {
  const { setUser, setToken } = useAuth();

  const [forgotStep, setForgotStep] = useState<"email" | "otp" | "reset">("email");
  const [userEmail, setUserEmail] = useState<string>("");

  return (
    <>
      {activePanel === "login" && (
        <LoginForm
          isOpen={true}
          closeModal={onClose}
          onSwitch={() => onSwitch("signup")}
          openForgotPassword={() => onSwitch("forgot")}
          setUser={setUser}
          setToken={setToken}
        />
      )}

      {activePanel === "signup" && (
        <SignUp
          isOpen={true}
          closeModal={onClose}
          onSwitchToLogin={() => onSwitch("login")}
        />
      )}

      {activePanel === "forgot" && (
        <>
          {forgotStep === "email" && (
            <ForgotPassword
              isOpen={true}
              closeModal={onClose}
              onBackToLogin={() => onSwitch("login")}
              onProceedToOTP={(email: string) => {
                setUserEmail(email);
                setForgotStep("otp");
              }}
            />
          )}

          {forgotStep === "otp" && (
            <OTPForm
              isOpen={true}
              email={userEmail}
              closeModal={onClose}
              onBackToForgot={() => setForgotStep("email")}
              onProceedToReset={() => setForgotStep("reset")}
            />
          )}

          {forgotStep === "reset" && (
            <ResetPassword
              isOpen={true}
              closeModal={onClose}
              onBackToLogin={() => onSwitch("login")}
            />
          )}
        </>
      )}
    </>
  );
};

export default LayoutManager;
